import type { Rarity } from '@tarot/contracts';

export const RARITY_NAME: Record<Rarity, string> = { common: 'Обычный', rare: 'Редкий', event: 'Ивентовый' };

export const Badge = ({ rarity }: { rarity: Rarity }) => <span className={`badge-r ${rarity}`}>{RARITY_NAME[rarity]}</span>;

export const Skeleton = ({ h }: { h: number }) => <div className="skeleton" style={{ height: h }} />;

export const Empty = ({ icon, text, action }: { icon: string; text: string; action?: React.ReactNode }) => (
  <div className="empty"><div className="ic">{icon}</div>{text}{action && <><br />{action}</>}</div>
);

export const fmtTime = (sec: number) => {
  const hh = Math.floor(sec / 3600), mm = Math.floor((sec % 3600) / 60);
  return hh ? `${hh} ч ${mm} мин` : `${mm} мин`;
};

export const plural = (n: number, one: string, few: string, many: string) =>
  n % 10 === 1 && n % 100 !== 11 ? one : [2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100) ? few : many;

/** Markdown-lite → безопасный HTML: ### заголовки, **жирный**, *курсив*, абзацы. */
export function mdToHtml(text: string): string {
  const esc = (s: string) => s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
  const inline = (s: string) => esc(s).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/\*(.+?)\*/g, '<em>$1</em>');
  let out = '';
  let para: string[] = [];
  const flush = () => { if (para.length) { out += `<p>${para.join(' ')}</p>`; para = []; } };
  for (const raw of text.split('\n')) {
    const l = raw.trim();
    if (!l) { flush(); continue; }
    if (l.startsWith('### ') || l.startsWith('## ')) { flush(); out += `<h3>${inline(l.replace(/^#+\s/, ''))}</h3>`; continue; }
    para.push(inline(l));
  }
  flush();
  return out;
}

export const Markdown = ({ text, cursor }: { text: string; cursor?: boolean }) => (
  <div className="md"><span dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />{cursor && <span className="cursor" />}</div>
);
